<template>
  <div id="register">
    <h3 class="greetingHeader">Welcome To PreEvent</h3>

    <b-container>
      <DialogContainer v-if="resetSuccess">
        <div class="resetLink">
          <h3 class="text-success">Reset password success</h3>
          <p>
            Your password has been successfully reset. You can now log in with
            your new password.
          </p>
          <router-link to="/login"><b-button>Login</b-button></router-link>
        </div>
      </DialogContainer>
      <DialogContainer v-if="resetFailed">
        <div class="resetLinkFailed">
          <h3 class="text-danger">Reset password failed</h3>
          <p>
            Oops! There was an error resetting your password. Please try again
            later.
          </p>
          <b-button @click="toggleDialog">Try again</b-button>
        </div>
      </DialogContainer>
      <b-form @submit.prevent="handleSubmit" id="registerForm">
        <!-- Row 1: First Name and Last Name -->
        <b-row>
          <h3 class="">Reset password</h3>
          <p>
            Please enter your email address, and we'll email you a link to reset
            your password
          </p>
        </b-row>
        <!-- Row 2: Email, Password, and Re-enter Password -->
        <b-row>
          <b-col md="12">
            <b-form-group label="Password" label-for="password">
              <div class="password-wrapper">
                <b-form-input
                  id="password"
                  :type="passwordType"
                  v-model="form.password"
                  placeholder="Enter your password"
                ></b-form-input>
                <b-button
                  @click="togglePasswordVisibility"
                  class="password-toggle"
                  variant="link"
                >
                  <i :class="eyeIconClass"></i>
                </b-button>
              </div>
              <span class="error-message" v-if="errors.password">{{
                errors.password
              }}</span>
            </b-form-group>

            <b-form-group label="Confirm Password" label-for="password">
              <div class="password-wrapper">
                <b-form-input
                  id="confirmPassword"
                  :type="passwordType2"
                  v-model="form.rePassword"
                  placeholder="Reenter your password"
                ></b-form-input>
                <b-button
                  @click="togglePasswordVisibility2"
                  class="password-toggle"
                  variant="link"
                >
                  <i :class="eyeIconClass2"></i>
                </b-button>
              </div>
              <span v-if="errors.confirmPassword" class="error-message">{{
                errors.confirmPassword
              }}</span>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Row 3: Register Button -->
        <b-row>
          <b-col>
            <b-form-group>
              <b-button
                class="w-100"
                type="submit"
                id="registerButton"
                :disabled="showLoading"
              >
                <template v-if="showLoading">
                  <img
                    src="../../assets/admin_loading.gif"
                    alt="Loading"
                    class="loader"
                  />
                </template>
                <template v-else> Save </template>
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <b-container class="text-center">
        <router-link to="/login" id="loginLink">Login</router-link>
      </b-container>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import { API_BASE_URL } from "@/utils/apiBase";
import DialogContainer from "@/components/DialogContainer.vue";

export default {
  components: {
    DialogContainer,
  },
  data() {
    return {
      resetSuccess: false,
      resetFailed: false,
      showLoading: false,
      form: {
        password: "",
        passwordVisible: false,
        rePasswordVisible: false,
        rePassword: "",
      },
      errors: {
        password: "",
        confirmPassword: "",
      },
    };
  },
  computed: {
    passwordType() {
      return this.form.passwordVisible ? "text" : "password";
    },
    passwordType2() {
      return this.form.rePasswordVisible ? "text" : "password";
    },
    eyeIconClass() {
      return this.form.passwordVisible ? "fas fa-eye" : "fas fa-eye-slash";
    },
    eyeIconClass2() {
      return this.form.rePasswordVisible ? "fas fa-eye" : "fas fa-eye-slash";
    },
  },
  methods: {
    validateForm() {
      this.errors.password = this.form.password ? "" : "Password is required";
      this.errors.confirmPassword =
        this.form.password !== this.form.rePassword ? "Mismatch password" : "";
    },
    handleSubmit() {
      this.showLoading = true;
      this.validateForm();
      if (this.errors.password || this.errors.confirmPassword) {
        this.showLoading = false;
        // after request sa server
        return; // Stop form submission if there are errors
      }

      axios
        .post(`${API_BASE_URL}/reset-password`, {
          token: this.$route.params.token,
          password: this.form.password,
        })
        .then((response) => {
          console.log('Response', response)
          this.showLoading = false;
          this.resetSuccess = true;
        })
        .catch((error) => {
          console.error("Reset password error:", error.response.data);
          this.errors = error;
          this.showLoading = false;
          this.resetFailed = true;
        });
    },
    togglePasswordVisibility() {
      this.form.passwordVisible = !this.form.passwordVisible;
    },
    togglePasswordVisibility2() {
      this.form.rePasswordVisible = !this.form.rePasswordVisible;
    },
    toggleDialog() {
      this.resetFailed = false;
    },
  },
  mounted: function () {
    console.log(this.$route.params.token);
  },
};
</script>

<style scoped>
#register {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #bfc7d6;
  padding: 40px 40px 120px 40px;
  border-radius: 5px;
  font-family: "Kumbh Sans", sans-serif;
  font-weight: 600;
}

h1 {
  font-weight: 600;
}
.greetingHeader {
  margin-bottom: 40px;
}
p {
  font-size: 12px;
  margin-bottom: 30px;
  font-family: "Kumbh Sans", sans-serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-style: normal;
  font-variation-settings: "YOPQ" 300;
}
h3 {
  font-family: "Kumbh Sans", sans-serif;
  font-optical-sizing: auto;
  font-weight: 800;
  font-style: normal;
  font-variation-settings: "YOPQ" 300;
}

#registerButton {
  background-color: #23305b;
  margin: 20px auto 40px auto;
}

/* ---------------------for password eye icon----------------------------- */
.password-wrapper {
  position: relative;
}

.password-toggle {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
}

.password-toggle i {
  font-size: 1.25rem;
  color: black;
}

@media (min-width: 600px) {
  #register {
    width: 550px;
  }
}

#loginLink {
  color: #23305b;
  text-decoration: none;
}

/* ---------------------error message----------------------------- */
.error-message {
  color: red;
  font-size: 0.875rem;
  margin-top: 5px;
}

/* ---------------------Dialog Box----------------------------- */

.resetLink,
.resetLinkFailed {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid black;
  background-color: white;
  padding: 40px 20px 20px 40px;
  border-radius: 5px;
  font-family: "Kumbh Sans", sans-serif;
  font-weight: 600;
}
.resetLinkFailed {
  border: solid red 1px;
}

/* ------------------------loading gif--------------------------------- */
.loader {
  width: 20px; /* Adjust size as needed */
  height: 20px;
  display: inline-block;
  vertical-align: middle;
}
</style>
